module.exports = __webpack_public_path__ + "static/media/icon-barcode.f19ef28b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-barcode.svg
// module id = 1239
// module chunks = 19